export default {
    ourPortfolio: 'Our Portfolio',
    companyDescription: 'We solve your business problems with software solutions.',
    customSoftware: 'Creating software is our mission to achieve your business goals ! Even on desktop or web applications. Just share your idea with us.',
    website: 'We could create websites of any kind such as an organization\'s site or site for specific tasks !',
    dataScraping: 'Any problems with gathering data to shape your business ? Let us help! we make it easier with automation tools and process it as you need.',
    contact: 'Contact'
}
